import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {MarkdownDialog} from '../../models/markdown-dialog';
import {MarkdownComponent, provideMarkdown} from 'ngx-markdown';
import {CloseableDialogComponent} from '../closeable-dialog/closeable-dialog.component';

@Component({
  selector: 'app-markdown-dialog',
  imports: [
    MatDialogContent,
    MarkdownComponent,
    CloseableDialogComponent
  ],
  templateUrl: './markdown-dialog.component.html',
  styleUrl: './markdown-dialog.component.scss',
  providers: [
    provideMarkdown(),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MarkdownDialogComponent {
  private readonly dialogRef: MatDialogRef<MarkdownDialogComponent> = inject(MatDialogRef);
  readonly data: MarkdownDialog = inject<MarkdownDialog>(MAT_DIALOG_DATA);

  toggleMaximize(isMaximized: boolean): void {
    if (isMaximized) {
      this.dialogRef.updateSize('100vw', '100vh');
    } else {
      this.dialogRef.updateSize('80vw', '80vw');
    }
  }
}
